const utils = {
    methods: {
        userIsLoggedIn() {
            const auth = sessionStorage.getItem('authentication');
            if (auth !== null && auth !== 'null' && auth !== '{}') {
                let authentication = JSON.parse(auth);
                if (authentication['signed-in']) {
                    return true;
                }
            }
            return false;
        },
        capitalizeFirstLetter(string) {
            if (string) {
                //capitalize only the first letter of the string.
                return string.charAt(0).toUpperCase() + string.slice(1);
            }
            return '';
        },
        b64toBlob(b64Data, contentType = '', sliceSize = 512) {
            const byteCharacters = atob(b64Data);
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                const slice = byteCharacters.slice(offset, offset + sliceSize);

                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }

            const blob = new Blob(byteArrays, { type: contentType });
            return blob;
        },
        capitalizeWords(string) {
            if (string) {
                //capitalize all words of a string.
                return string.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
            }
            return '';
        },
        draw_curve_aux(ctx, points, tension, color = "black", size = 10) {

            ctx.beginPath();
            ctx.moveTo(points[0].x, points[0].y);

            var t = (tension != null) ? tension : 1;
            for (var i = 0; i < points.length - 1; i++) {
                var p0 = (i > 0) ? points[i - 1] : points[0];
                var p1 = points[i];
                var p2 = points[i + 1];
                var p3 = (i != points.length - 2) ? points[i + 2] : p2;

                var cp1x = p1.x + (p2.x - p0.x) / 6 * t;
                var cp1y = p1.y + (p2.y - p0.y) / 6 * t;

                var cp2x = p2.x - (p3.x - p1.x) / 6 * t;
                var cp2y = p2.y - (p3.y - p1.y) / 6 * t;

                ctx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, p2.x, p2.y);
                ctx.strokeStyle = color;
                ctx.lineWidth = size;
                // console.log('Curve ' + i)
            }
            ctx.stroke();
        },
        getBezierXY(t, sx, sy, cp1x, cp1y, cp2x, cp2y, ex, ey) {
            return {
                x: Math.pow(1 - t, 3) * sx + 3 * t * Math.pow(1 - t, 2) * cp1x + 3 * t * t * (1 - t) * cp2x + t * t * t * ex,
                y: Math.pow(1 - t, 3) * sy + 3 * t * Math.pow(1 - t, 2) * cp1y + 3 * t * t * (1 - t) * cp2y + t * t * t * ey
            };
        },
        aux_coords(p0, p1, p2, p3, x, t) {
            var cp1x = p1.x + (p2.x - p0.x) / 6 * t;
            var cp1y = p1.y + (p2.y - p0.y) / 6 * t;
            var cp2x = p2.x - (p3.x - p1.x) / 6 * t;
            var cp2y = p2.y - (p3.y - p1.y) / 6 * t;

            for (let t = 0; t < 1.0; t += 0.0001) {
                let res = this.getBezierXY(t, p0.x, p0.y, cp1x, cp1y, cp2x, cp2y, p3.x, p3.y);
                if (res.x - 0.225 < x && x < res.x + 0.225) {
                    return res;
                }
            }
            return p1;
        },
        get_near_coord(point, points_in_curve, x, t) {

            let real_coord;

            for (let i = 0; i < point.length; i++) {
                let p_chp = point[i];

                let p0 = points_in_curve[p_chp - 2];
                let p1 = points_in_curve[p_chp - 1];
                let p2 = points_in_curve[p_chp];
                let p3 = points_in_curve[p_chp + 1];

                let coord = this.aux_coords(p0, p1, p2, p3, x, t);
                if (real_coord === undefined || (coord.x - x <= real_coord.x - x)) {
                    real_coord = coord;
                }
            }

            return real_coord;
        },
        getMaxOfArray(objArray, alt) {
            let block = Object.keys(objArray[alt]).map((key) => {
                return objArray[alt][key].length;
            });
            return Math.max.apply(null, block);
        },
        get_points_in_bezier_curve(points_in_curve, tension, num_points) {

            var t = (tension != null) ? tension : 1;

            let first_x = points_in_curve[0].x;
            let last_x = points_in_curve[points_in_curve.length - 1].x;
            let diff = last_x - first_x;

            let coord = [];
            for (let j = 0; j < num_points; j++) {
                let x = (diff / (num_points + 1)) * (j + 1);
                let point = [];
                for (let i = points_in_curve.length - 2; i > 1; i--) {
                    if (x >= points_in_curve[i - 2].x && x <= points_in_curve[i + 1].x) {
                        point.push(i);
                    }
                }
                let ch = this.get_near_coord(point, points_in_curve, x, t);
                coord.push(ch);
            }

            // console.log(coord);
            return coord;

        },
        sleep(milliseconds) {
            var start = new Date().getTime();
            for (var i = 0; i < 1e7; i++) {
                if ((new Date().getTime() - start) > milliseconds) {
                    break;
                }
            }
        },
        get_nearest_step(pos, array) {
            for (let i = 0; i < array.length; i++) {
                if (i == 0 && pos < array[i + 1][1]) {
                    return [array[0], array[1]];
                } else if (i < array.length - 1 && (pos >= array[i][1] && pos < array[i + 1][1])) {
                    return [array[i], array[i + 1]];
                }
            }
            return [array[array.length - 1]];
        }
    }
};

export default utils;